@if (item) {
  <div class="routing">
    <div class="routing__column">
      @if (item.transportMode) {
        <div class="routing__column--label">Transport Mode</div>
        <span>{{ item.transportMode }}</span>
      }
    </div>

    <div class="routing__column">
      @if (item.status) {
        <div class="routing__column--label">Status</div>
        <span>{{ item.status }}</span>
      }
    </div>

    <div class="routing__column">
      @if (item.routing.vesselFlight) {
        @if (item.transportMode === 'Air') {
          <div class="routing__column--label">Flight</div>
          @for (item of item.routing.vesselFlight | commaSeparatedToArray; track item) {
            <div>{{ item }}</div>
          }
        } @else if (item.transportMode === 'Ocean') {
          <div class="routing__column--label">Vessel</div>
          @for (item of item.routing.vesselFlight | commaSeparatedToArray; track item) {
            <div>{{ item }}</div>
          }
        }
      }
    </div>

    <div class="routing__column">
      @if (item.routing && (item.routing.carrier || item.routing.carrierName)) {
        <div class="routing__column--label">Carrier</div>
        <span>{{ item | carrierInParenthesis }}</span>
      }
    </div>

    <div class="routing__column">
      <app-routing-booked [routing]="item.routing"></app-routing-booked>
    </div>

    <div class="routing__column">
      <app-routing-confirmed [routes]="item.allRoutes"></app-routing-confirmed>
    </div>
  </div>
}
